import { BOX_OFFER_TEST_DATA, LIGHT_BOX_OFFER_TEST_DATA } from "@modules/boxOffer/services/boxOfferApi.fake"
import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import {
  LIGHT_PROGRAM_BUNDLE_TEST_DATA,
  LIGHT_PROGRAM_TEST_DATA,
  PROGRAM_TEST_DATA,
} from "@modules/programs/gateway/programApi.fake"
import { type BoxPromoCodeDto } from "@modules/promoCode/gateway/boxPromoCodeDto"
import { type PromoCodeApiGateway } from "@modules/promoCode/gateway/promoCodeApi.gateway"
import { type CoachPromoCodeDto, PromoCodeStatus } from "@modules/promoCode/gateway/promoCodeDto"
import { type BoxPromoCodeDraft } from "@modules/promoCode/types/boxPromoCodeTypes"
import { type PromoCodeDraft } from "@modules/promoCode/types/promoCodeTypes"
import dayjs from "dayjs"

const COMPLETE_PERCENTAGE_REDUCTION_DRAFT: PromoCodeDraft = {
  title: "Test Promo Code",
  code: "TEST123",
  type: CouponType.PERCENT,
  value: 10,
  startAt: "2024-09-27",
  expirationDate: undefined,
  durationInMonths: undefined,
  maxAttendees: undefined,
  onlyNewCustomer: false,
  selectedProgramIds: [PROGRAM_TEST_DATA.PRICED_INFINITE_PROGRAM.id],
  selectedProgramBundleIds: [],
  createdAt: "2024-09-27",
}

const COMPLETE_FIXED_REDUCTION_DRAFT: PromoCodeDraft = {
  title: "Test Promo Code",
  code: "TEST123",
  type: CouponType.DIRECT,
  value: 10,
  startAt: "2024-09-27",
  expirationDate: undefined,
  durationInMonths: undefined,
  maxAttendees: undefined,
  onlyNewCustomer: false,
  selectedProgramIds: [PROGRAM_TEST_DATA.PRICED_INFINITE_PROGRAM.id],
  selectedProgramBundleIds: [],
  createdAt: "2024-09-27",
}

const BOX_COMPLETE_PERCENTAGE_REDUCTION_DRAFT: BoxPromoCodeDraft = {
  title: "Test Promo Code",
  code: "TESTBOX123",
  type: CouponType.PERCENT,
  value: 10,
  expirationDate: undefined,
  durationInMonths: undefined,
  maxAttendees: undefined,
  onlyNewCustomer: false,
  selectedBoxOfferIds: [BOX_OFFER_TEST_DATA.BOX_OFFER_ITEM_SUBSCRIPTION.id],
  createdAt: "2024-09-27",
}

const BOX_COMPLETE_FIXED_REDUCTION_DRAFT: BoxPromoCodeDraft = {
  title: "Test Promo Code",
  code: "TESTBOX123",
  type: CouponType.DIRECT,
  value: 10,
  expirationDate: undefined,
  durationInMonths: undefined,
  maxAttendees: undefined,
  onlyNewCustomer: false,
  selectedBoxOfferIds: [BOX_OFFER_TEST_DATA.BOX_OFFER_ITEM_SUBSCRIPTION.id],
  createdAt: "2024-09-27",
}

export const PROMOCODE_FORM_TEST_DATA = {
  COMPLETE_PERCENTAGE_REDUCTION_DRAFT,
  COMPLETE_FIXED_REDUCTION_DRAFT,
  COMPLETE_EXPIRING_REDUCTION_DRAFT: {
    ...COMPLETE_PERCENTAGE_REDUCTION_DRAFT,
    expirationDate: dayjs().add(1, "month").format("YYYY-MM-DD"),
  },
  COMPLETE_LIMITED_DURATION_REDUCTION_DRAFT: {
    ...COMPLETE_PERCENTAGE_REDUCTION_DRAFT,
    durationInMonths: 10,
  },
  COMPLETE_LIMITED_CUSTOMER_REDUCTION_DRAFT: {
    ...COMPLETE_PERCENTAGE_REDUCTION_DRAFT,
    maxAttendees: 10,
  },
  COMPLETE_NEW_CUSTOMER_REDUCTION_DRAFT: {
    ...COMPLETE_PERCENTAGE_REDUCTION_DRAFT,
    onlyNewCustomer: true,
  },
  INCOMPLETE_REDUCTION_DRAFT: {
    ...COMPLETE_PERCENTAGE_REDUCTION_DRAFT,
    code: "",
    selectedProgramIds: [],
  },
  BOX_COMPLETE_PERCENTAGE_REDUCTION_DRAFT,
  BOX_COMPLETE_FIXED_REDUCTION_DRAFT,
  BOX_COMPLETE_EXPIRING_REDUCTION_DRAFT: {
    ...BOX_COMPLETE_PERCENTAGE_REDUCTION_DRAFT,
    expirationDate: dayjs().add(1, "month").format("YYYY-MM-DD"),
  },
  BOX_COMPLETE_LIMITED_DURATION_REDUCTION_DRAFT: {
    ...BOX_COMPLETE_PERCENTAGE_REDUCTION_DRAFT,
    durationInMonths: 10,
  },
  BOX_COMPLETE_LIMITED_CUSTOMER_REDUCTION_DRAFT: {
    ...BOX_COMPLETE_PERCENTAGE_REDUCTION_DRAFT,
    maxAttendees: 10,
  },
  BOX_COMPLETE_NEW_CUSTOMER_REDUCTION_DRAFT: {
    ...BOX_COMPLETE_PERCENTAGE_REDUCTION_DRAFT,
    onlyNewCustomer: true,
  },
  BOX_INCOMPLETE_REDUCTION_DRAFT: {
    ...BOX_COMPLETE_PERCENTAGE_REDUCTION_DRAFT,
    code: "",
    selectedBoxOfferIds: [],
  },
}

const PERCENTAGE_REDUCTION_PROMOCODE: CoachPromoCodeDto = {
  id: "fake-promocode-id",
  title: "Fake Percentage Promo Code",
  code: "FAKE10",
  type: CouponType.PERCENT,
  value: 10,
  createdAt: "2024-09-27",
  startAt: "2024-09-27",
  expirationDate: dayjs().add(1, "month").format("YYYY-MM-DD"),
  durationInMonths: 12,
  maxAttendees: 100,
  onlyNewCustomer: false,
  archived: false,
  archivedStatus: null,
  programs: [LIGHT_PROGRAM_TEST_DATA.PRICED_INFINITE_PROGRAM],
  programBundles: [],
}

const PAST_PERCENTAGE_REDUCTION_PROMOCODE: CoachPromoCodeDto = {
  id: "past-fake-promocode-id",
  title: "Past Fake Percentage Promo Code",
  code: "PAST10",
  type: CouponType.PERCENT,
  value: 10,
  createdAt: "2024-09-27",
  startAt: "2024-09-27",
  expirationDate: dayjs().add(-1, "month").format("YYYY-MM-DD"),
  durationInMonths: 12,
  maxAttendees: 100,
  onlyNewCustomer: false,
  archived: true,
  archivedStatus: PromoCodeStatus.EXPIRED,
  programs: [LIGHT_PROGRAM_TEST_DATA.PRICED_INFINITE_PROGRAM],
  programBundles: [],
}

const BOX_PERCENTAGE_REDUCTION_PROMOCODE: BoxPromoCodeDto = {
  id: "fake-promocode-id",
  title: "Fake Percentage Promo Code",
  code: "FAKE10",
  type: CouponType.PERCENT,
  value: 10,
  createdAt: "2024-09-27",
  startAt: "2024-09-27",
  expirationDate: dayjs().add(1, "month").format("YYYY-MM-DD"),
  durationInMonths: 12,
  maxAttendees: 100,
  onlyNewCustomer: false,
  archived: false,
  archivedStatus: null,
  boxOffers: [LIGHT_BOX_OFFER_TEST_DATA.LIGHT_BOX_OFFER_SUBSCRIPTION],
}

const BOX_PAST_PERCENTAGE_REDUCTION_PROMOCODE: BoxPromoCodeDto = {
  id: "past-fake-promocode-id",
  title: "Past Fake Percentage Promo Code",
  code: "PAST10",
  type: CouponType.PERCENT,
  value: 10,
  createdAt: "2024-09-27",
  startAt: "2024-09-27",
  expirationDate: dayjs().add(-1, "month").format("YYYY-MM-DD"),
  durationInMonths: 12,
  maxAttendees: 100,
  onlyNewCustomer: false,
  archived: true,
  archivedStatus: PromoCodeStatus.EXPIRED,
  boxOffers: [LIGHT_BOX_OFFER_TEST_DATA.LIGHT_BOX_OFFER_SUBSCRIPTION],
}

export const PROMOCODE_FAKE_DATA = {
  PERCENTAGE_REDUCTION_PROMOCODE,
  PAST_PERCENTAGE_REDUCTION_PROMOCODE,
  BOX_PERCENTAGE_REDUCTION_PROMOCODE,
  BOX_PAST_PERCENTAGE_REDUCTION_PROMOCODE,
}

export class FakePromoCodeApi implements PromoCodeApiGateway {
  promocodes: CoachPromoCodeDto[] = []

  givenPromoCodes(promocodes: CoachPromoCodeDto[]) {
    this.promocodes = promocodes
  }
  getPromoCodes(expired: boolean): Promise<CoachPromoCodeDto[]> {
    if (expired) return Promise.resolve(this.promocodes.filter((p) => p.archived))
    else return Promise.resolve(this.promocodes.filter((p) => !p.archived))
  }
  createPromoCode(promoCodeDraft: PromoCodeDraft): Promise<CoachPromoCodeDto> {
    this.promocodes = [
      {
        ...promoCodeDraft,
        id: "created-promocode",
        archived: false,
        archivedStatus: PromoCodeStatus.MAX_ATTENDEES,
        maxAttendees: 0,
        programs: [],
        programBundles: [],
        createdAt: new Date().toISOString(),
        expirationDate: null,
        durationInMonths: null,
        onlyNewCustomer: false,
        startAt: null,
      },
    ]
    if (this.promocodes[0]) return Promise.resolve(this.promocodes[0])
    else return Promise.reject(new Error("Promo code not created"))
  }
  updatePromoCode(id: string, promoCodeDraft: PromoCodeDraft): Promise<CoachPromoCodeDto> {
    const updatedPromoCodeIndex = this.promocodes.findIndex((p) => p.id === id)

    if (updatedPromoCodeIndex >= 0)
      this.promocodes[updatedPromoCodeIndex] = {
        ...promoCodeDraft,
        id,
        archived: false,
        archivedStatus: null,
        programs: promoCodeDraft.selectedProgramIds.map(() => LIGHT_PROGRAM_TEST_DATA.PRICED_INFINITE_PROGRAM),
        programBundles: promoCodeDraft.selectedProgramBundleIds.map(
          () => LIGHT_PROGRAM_BUNDLE_TEST_DATA.PRICED_INFINITE_PROGRAM_BUNDLE,
        ),
        createdAt: new Date().toISOString(),
        expirationDate: null,
        durationInMonths: null,
        onlyNewCustomer: false,
        maxAttendees: 0,
        startAt: null,
      }

    if (this.promocodes[updatedPromoCodeIndex]) return Promise.resolve(this.promocodes[updatedPromoCodeIndex])
    else return Promise.reject(new Error("Promo code not found"))
  }
  deletePromoCode(id: string): Promise<void> {
    const updatedPromoCodeIndex = this.promocodes.findIndex((p) => p.id === id)

    if (updatedPromoCodeIndex >= 0) this.promocodes.splice(updatedPromoCodeIndex, 1)

    return Promise.resolve()
  }
}
